export const SET_CURRENT_USER = 'user/SET_CURRENT';

export const setCurrentUser = payload => dispatch => {
  dispatch({ type: SET_CURRENT_USER, payload });
  return Promise.resolve();
};



// WEBPACK FOOTER //
// ./app/actions/set-current-user.js